import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import adminRouteAccessApi from '../api/adminRouteAccessApi';

const useRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname.startsWith('/ai-chatbot/administrator')) {
            const fullPath = location.pathname + location.search;
            const now = Date.now();
            
            const lastLogged = sessionStorage.getItem('lastLoggedRoute');
            const lastLoggedTime = parseInt(sessionStorage.getItem('lastLoggedTime') || '0', 10);

            // Prevent logging the exact same path if it was logged less than 5 seconds ago (covers React Strict Mode and F5 spam)
            if (lastLogged === fullPath && now - lastLoggedTime < 5000) {
                return;
            }

            sessionStorage.setItem('lastLoggedRoute', fullPath);
            sessionStorage.setItem('lastLoggedTime', now.toString());
            
            // Fire and forget
            adminRouteAccessApi.logRouteAccess(fullPath).catch(err => {
                console.error("Failed to log route access:", err);
            });
        }
    }, [location.pathname, location.search]);
};

export default useRouteTracker;
